import React from "react";

const StatusContext = React.createContext({
  getStatusForField: field => []
});

export default StatusContext;
